import { ComponentProps } from 'react';

import { Box } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';

import { containerClass, footerContainerClass } from './PriceDetails.css';

interface ContainerProps extends ComponentProps<typeof Box> {
  className?: string;
}

interface FooterContainerProps extends ComponentProps<typeof Box> {
  className?: string;
}

export const Container = ({ className, ...props }: ContainerProps) => (
  <Box className={getClassNames(containerClass, className)} {...props} />
);

export const FooterContainer = ({ className, ...props }: FooterContainerProps) => (
  <Box className={getClassNames(footerContainerClass, className)} {...props} />
);
